import { Controller } from 'react-hook-form'

import PatientFormField from '../PatientFormField'
import { useFormContextPatient } from '../_utils'

const InsOid = () => {
    const { control } = useFormContextPatient()

    return (
        <Controller
            control={control}
            name="insOid"
            render={({ field }) => (
                <PatientFormField
                    variant="input"
                    label="OID"
                    disabled
                    status={{
                        valid: Boolean(field.value),
                        error: false,
                    }}
                    size="0.5"
                    dataCyScope="PatientField"
                    {...field}
                    value={field.value ?? undefined}
                    placeholder="OID"
                />
            )}
        />
    )
}

export default InsOid
